import Navbar from "./Navbar";

export default function NavbarOther() {
   return (
       <div className="navbar_other">
          <Navbar textColor={'text-vol'} isHomepage={false} />
       </div>
   );
}
